import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import './styles.css'
import { DropdownMenu, Button, ThemeChangeButton } from '../index'
import { headerStrings } from '../../utils'
import { ThemeContext, ThemeContextType } from '../../contexts'
import LoginAccess from '../LoginAccess'

const Header = () => {
    const navigate = useNavigate()
    const { toggleTheme } = useContext<ThemeContextType>(ThemeContext);

    const burgerItems = [
        <Button key='home' onClick={() => navigate('')}>{headerStrings.homeButton}</Button>,
        <Button key='deckbuilder' onClick={() => navigate('deckbuilder')}>{headerStrings.deckbuilderButton}</Button>,
        <Button key='mydecks' onClick={() => navigate('mydecks')}>{headerStrings.myDecksButton}</Button>,
        <Button key='articles' onClick={() => navigate('articles')}>{headerStrings.articlesButton}</Button>
    ]

    const configurationItems = [
        <ThemeChangeButton key='themechange' onClick={() => toggleTheme()}/>
    ]

    return <div className='header-wrapper'>
        <div>
            <DropdownMenu dropdownMenuAlign='left' className='page-links-burger' items={burgerItems} />
            <div className='page-links-wrapper'>
                {burgerItems.map(el => el)}
            </div>
        </div>
        <div className='left-wrapper'>
            <LoginAccess />
            <DropdownMenu type='configuration' items={configurationItems} />
        </div>
    </div>
}

export default Header
